"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.native.help': 'La conoscenza nativa è nascosta agli utenti regolari ma disponibile per gli assistenti IA',
};
